import { useEffect, useState } from "react";

const CHAPTERS = [
  { id: "scene-noise", n: "01", label: "The Noise" },
  { id: "scene-doorway", n: "02", label: "The Doorway" },
  { id: "scene-intention", n: "03", label: "Intention" },
  { id: "scene-arriving", n: "04", label: "Arrivals" },
  { id: "scene-encounter", n: "05", label: "Encounter" },
  { id: "scene-remains", n: "06", label: "What Remains" },
  { id: "scene-sanctum", n: "07", label: "Sanctum" },
  { id: "scene-crossing", n: "08", label: "Crossing" },
];

export default function ChapterRail() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    let tops = [];
    let raf = 0;
    const measure = () => {
      tops = CHAPTERS.map((c) => document.getElementById(c.id)?.offsetTop ?? 0);
    };
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        const y = window.scrollY + window.innerHeight * 0.45;
        let idx = 0;
        tops.forEach((top, i) => {
          if (top <= y) idx = i;
        });
        setActive((current) => (current === idx ? current : idx));
        raf = 0;
      });
    };
    measure();
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", measure, { passive: true });
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", measure);
    };
  }, []);

  const go = (id) => {
    if (window.__lenis) window.__lenis.scrollTo(`#${id}`, { duration: 1.8 });
    else document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav className="th-rail" data-testid="chapter-rail" aria-label="Chapters">
      {CHAPTERS.map((c, i) => (
        <button
          key={c.id}
          type="button"
          data-testid={`rail-${c.id}`}
          className={`th-rail-item ${i === active ? "is-active" : ""}`}
          onClick={() => go(c.id)}
        >
          <span className="th-rail-label">{c.label}</span>
          <span className="th-rail-num">{c.n}</span>
        </button>
      ))}
      <div className="th-progress" data-testid="chapter-progress">
        {CHAPTERS[active].n}
        <i />
        08
      </div>
    </nav>
  );
}
